import type { CatalogueEntry } from "../types";
import imageLight from "../images/national-trees.light.webp";
import imageDark from "../images/national-trees.dark.webp";

export const entry: CatalogueEntry = {
  slug: "national-trees",
  displayName: `National Trees`,
  datasetProductCode: `GEOSCAPE TREES`,
  subtitle: `Digital Representation of Tree Heights and Coverage.`,
  shortDescription: `Trees is a national digital dataset representing tree coverage and their associated heights for urban areas across each State and Territory in Australia.
The Trees theme consists of two layers: (1) Trees and (2) Trees Metadata. The Trees layer consists of a digital pixel representation tree coverage and their associated heights derived through DEMs, while the Trees Metadata layer represents any manipulations or insight into Trees layer pixels values, or absence thereof. The Theme is comprised of pre-defined urban areas at a two-metre resolution. The distribution corresponds to the Tree type pixel in the Urban Surface Cover product.`,
  metadata: {
    dateAdded: 1482105600000,
    dataType: ["Raster"],
    totalFeatureCount: 8682,
    updateFrequency: `Quarterly`,
    license: `Commercial`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/en/stable/trees.html`,
  productDescriptionLink: `https://docs.geoscape.com.au/en/stable/trees.html`,
  imageLight,
  imageDark,
  searchTags: `National Trees Geoscape Trees Arboriculture Biodiversity Botany Canopy Ecology Environmental Impact Nature Tree Coverage Urban Forestry`,
  detail: () => import("../details/national-trees").then((m) => m.detail),
};

export default entry;
